import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup, Col, Row, Input, InputGroupAddon, Button } from 'reactstrap';
import Icon from '../../../common/containers/icon';
const OptionActionsOther = ({
  onOption
}) => {
  const [current, setCurrent] = useState('');
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form, {
    style: {
      padding: 5
    },
    onSubmit: () => onOption(current)
  }, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(Input, {
    onChange: event => setCurrent(event.target.value),
    value: current,
    className: "t-oaoi-other-input"
  }), /*#__PURE__*/React.createElement(InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "t-oaoi-add-other",
    disabled: !current,
    onClick: () => onOption(current)
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  })))))));
};
OptionActionsOther.propTypes = {
  onOption: PropTypes.func.isRequired
};
export default OptionActionsOther;